/**
 * `/admin/*` sub-nav — TASK 10.4.
 *
 * The mock's two-link row (L651 on /admin/users, L681 on /admin/sync):
 * `Users · Sync status`, with `aria-current="page"` + bold on the active
 * side. ui-contract §3 names both ids — `users-link` / `sync-status-link` —
 * so they come from the shared TESTIDS registry, never string literals.
 *
 * The links are the ADMIN-ONLY navigation surface: a member never reaches
 * either page (MoreMenu hides the Admin row, the router bounces `/admin*` to
 * `/not-authorized`, and `requireAdmin` on the server is the real control —
 * see MoreMenu.js's header).
 *
 * @module
 */

import { TESTIDS } from '@streamymusic/shared';

import { append, el } from '../../components/primitives/dom.js';

/**
 * @param {{ active: 'users'|'sync' }} options
 * @returns {HTMLElement}
 */
export function AdminNav(options) {
  const { active } = options;

  /**
   * @param {{ label: string, href: string, testId: string, current: boolean }} link
   * @returns {HTMLElement}
   */
  const navLink = ({ label, href, testId, current }) =>
    el('a', {
      ...(current ? { className: 'sm-subnav__current' } : {}),
      text: label,
      testId,
      attrs: { href, ...(current ? { 'aria-current': 'page' } : {}) },
    });

  // mock L681 uses the 16px bottom margin, L651 the 14px one.
  const row = el('p', {
    className: active === 'sync' ? 'sm-subnav sm-subnav--16' : 'sm-subnav',
  });
  append(
    row,
    navLink({
      label: 'Users',
      href: '#/admin/users',
      testId: TESTIDS.USERS_LINK,
      current: active === 'users',
    }),
    document.createTextNode(' · '),
    navLink({
      label: 'Sync status',
      href: '#/admin/sync',
      testId: TESTIDS.SYNC_STATUS_LINK,
      current: active === 'sync',
    }),
  );
  return row;
}
